var _defs, _rect, _rect2, _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 600,
    viewBox: "0 0 800 600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ph-grad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4A0AB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B20D5D"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ph-dots",
    width: 26,
    height: 26,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.4,
    fill: "#ffffff",
    fillOpacity: 0.1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 600,
    fill: "url(#ph-grad)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 600,
    fill: "url(#ph-dots)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400,255)",
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("rect", {
    x: -70,
    y: -55,
    width: 140,
    height: 120,
    rx: 16,
    fill: "#ffffff",
    fillOpacity: 0.14,
    stroke: "#ffffff",
    strokeOpacity: 0.55,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -70,
    y: -55,
    width: 140,
    height: 34,
    rx: 16,
    fill: "#ffffff",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: -40,
    y1: -70,
    x2: -40,
    y2: -40,
    stroke: "#ffffff",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: -70,
    x2: 40,
    y2: -40,
    stroke: "#ffffff",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -32,
    cy: 10,
    r: 6,
    fill: "#ffffff",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 10,
    r: 6,
    fill: "#ffffff",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 10,
    r: 6,
    fill: "#ffffff",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -32,
    cy: 35,
    r: 6,
    fill: "#ffffff",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 35,
    r: 6,
    fill: "#ffffff",
    fillOpacity: 0.55
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 360,
    fontFamily: "DM Sans, Arial, sans-serif",
    fontSize: 22,
    fill: "#ffffff",
    fillOpacity: 0.9,
    textAnchor: "middle",
    letterSpacing: 1
  }, "\n    Image coming soon\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 392,
    fontFamily: "DM Sans, Arial, sans-serif",
    fontSize: 14,
    fill: "#ffffff",
    fillOpacity: 0.6,
    textAnchor: "middle",
    letterSpacing: 3
  }, "\n    EVENTFLOW\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPlaceholder);
export default __webpack_public_path__ + "static/media/img-placeholder.ab9415269c4e2bcd6e0085a4fdc1da7a.svg";
export { ForwardRef as ReactComponent };